import type { ILocation } from '@order-up/models';

/**
 * The name a CUSTOMER should see for a restaurant.
 *
 * `displayName` is the trading name the operator chose; `name` is the legal
 * entity, which is frequently "<Brand> LLC" and is not what a diner should be
 * shown. Every customer-facing surface must print this, never `restaurant.name`
 * directly.
 *
 * Lives in `packages/common` because BOTH customer-facing planes need it and
 * they cannot reach each other: `apps/restaurant` had the only copy, in its own
 * `src/lib/utils/restaurantData.ts`, so `apps/ordering` could not use it — and
 * that is exactly how `now.letsorderup.online/{slug}` shipped a page titled
 * "Order Online - house-of-pho-llc". Per CLAUDE.md, a rule both planes must
 * agree on belongs here, exported for the browser AND the server.
 */
export function getLocationDisplayName(
  locationRecord: Pick<ILocation, 'displayName' | 'name'> | null | undefined,
): string {
  return locationRecord?.displayName || locationRecord?.name || 'Unknown Restaurant';
}
